module.exports = __webpack_public_path__ + "static/media/Singapore.f42ea65f.png";